// Selectors
import { createSelector } from '@reduxjs/toolkit';
import { ApplicationState } from '../../store';


export const locationSelector = (state: ApplicationState) => state.locationState

export const locationLoadingSelector = createSelector(locationSelector, (state) => state.loading);
